import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { usePageContents } from '../contexts/PageContentContext';

const Instructors: React.FC = () => {
  const { getPageContent, loading } = usePageContents();
  const content = getPageContent('instructors');

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex items-center justify-center min-h-[250px] sm:min-h-[300px] md:min-h-[400px] mt-20">
          <div className="text-sm sm:text-base text-gray-500">로딩 중...</div>
        </div>
        <Footer />
      </div>
    );
  }

  const defaultDescription = '<p>동두천시 글로벌인재교육센터는 인지적으로 체험하는 과정을 통하여 언어를 효과적으로 습득하는 소통의 교육 공간을 위해 노력하고 있습니다.</p><p>21세기 세계시민을 위한 국제언어교육의 미션을 늘 마음에 새기며, 자연스럽게 노출하는 글로벌 언어 체험 활동으로 어려울 수 있는 언어학습을 흥미 있게 다가갈 수 있도록 선생님들과 함께 신나고 재미있게 이끌어 가겠습니다!</p>';
  const description = content?.description || defaultDescription;
  const imageUrl = content?.image_url || '/instructors.png';

  return (
    <>
      <SEO
        title="강사 소개"
        description="동두천시 글로벌인재교육센터의 원어민 강사진을 소개합니다. 다양한 국적의 전문 강사들이 함께합니다."
        keywords="동두천글로벌인재교육센터, 강사소개, 원어민강사, 이중언어강사"
        path="/about/instructors"
      />
      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Page Header */}
        <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&h=600&fit=crop&q=80"
              alt="Education"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>

          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">센터소개</p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">강사 소개</h1>
            <div className="w-16 sm:w-20 h-1 bg-white/70"></div>
          </div>
        </div>

        {/* Intro Section */}
        <div className="py-16 sm:py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-6 leading-relaxed">
              {content?.title_main || '강사 소개'}
            </h2>
            <div className="w-16 h-1 bg-green-500 mx-auto mb-8"></div>
            <div
              className="text-base sm:text-lg text-gray-600 leading-relaxed prose prose-base sm:prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>

        {/* Instructor Image */}
        <div className="flex-1 py-16 sm:py-20 bg-gray-50">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <img
              src={imageUrl}
              alt="글로벌인재교육센터 강사진 소개"
              className="w-full h-auto"
            />
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Instructors;
